// extracted by mini-css-extract-plugin
export default {"productDescription":"Aaa-z","featuredDescription":"Baa-z","description":"Caa-z","more":"Daa-z","descriptionSku":"Eaa-z"};